module.exports = __webpack_public_path__ + "images/category_lp/pc/customer1_f2cb501c9c76edcb4d11d3311cddf78b.jpg";